// extracted by mini-css-extract-plugin
module.exports = {"categorynav":"categorynav_categorynav__1NLMr","active":"categorynav_active__3cQwo"};